import React, { useState, useEffect } from 'react';
import { RadioGroup, FormControlLabel, Radio, Typography, FormHelperText } from '@mui/material';
import { MuiTelInput } from 'mui-tel-input';
import { useSelector } from 'react-redux';
import { getActiveLanguage } from 'react-localize-redux';
import country_flags from '../../../helpers/country_flags';

function RenderPhoneField({ input, meta: { invalid, touched, error, active }, ...custom }) {
	const { language, available_languages } = useSelector((state) => ({
		language: getActiveLanguage(state.localize).code,
		available_languages: state.settings.site.available_languages
			.map((available_language) => available_language.code.split('-')[1])
			.filter((available_language) => available_language),
	}));

	const [phoneOption, setPhoneOption] = useState(input.value ? '0' : '1');

	const handleRadioChange = (event) => {
		setPhoneOption(event.target.value);
    if (event.target.value === '1') {
			input.onChange('');
    }
	};

	useEffect(() => {
		if (!input.value) {
			setPhoneOption('1');
		} else {
			setPhoneOption('0');
		}
	}, [input.value]);

	return (
		<div>
			{custom.inputdata.title && <Typography>{custom.inputdata.title}</Typography>}

			{custom.inputdata.showRadioButtons && (
				<RadioGroup row value={phoneOption} onChange={handleRadioChange} aria-label="phone-options" name="phone-options">
					<FormControlLabel
						value="0"
						control={<Radio />}
						disabled={custom.inputdata.readonly}
						label={custom.inputdata.label_radio_with_phone}
					/>
					<FormControlLabel
						value="1"
						control={<Radio />}
						disabled={custom.inputdata.readonly}
						label={custom.inputdata.label_radio_without_phone}
					/>
				</RadioGroup>
			)}

			{!custom.inputdata.showRadioButtons || phoneOption === '0' ? (
				<MuiTelInput
					{...input}
					disableFormatting
					getFlagElement={(isoCode, { imgProps, countryName, isSelected }) => {
						return <img width="26" src={country_flags[isoCode]} aria-label={countryName} />;
					}}
					preferredCountries={available_languages}
					langOfCountryName={language}
					defaultCountry={language.split('-')[1]}
					id={custom.inputdata.id}
					name={custom.inputdata.name}
					label={custom.inputdata.label}
					placeholder={custom.inputdata.placeholder}
					fullWidth
					variant="outlined"
					disabled={custom.inputdata.readonly}
					error={touched && invalid && !active}
					helperText={touched && !active && error}
					onChange={(event, info) => {
						input.onChange(event); // Update the input value
						if (typeof custom.inputdata.onChange !== 'undefined') {
							custom.inputdata.onChange(event.target.value);
						}
					}}
					type={custom.inputdata.type}
					size={custom.inputdata.size || null}
					{...custom}
					inputProps={{
						step: custom.inputdata.props ? custom.inputdata.props.step : null,
						min: custom.inputdata.props ? custom.inputdata.props.min : null,
						maxLength: custom.inputdata.props ? custom.inputdata.props.maxLength : null,
						className: custom.inputdata.disableNumberArrows ? 'number-input' : null,
					}}
				/>
			) : null}

			{/* Helper text */}
			<FormHelperText id="helper-text-phone-field">{custom.inputdata.helperText}</FormHelperText>
		</div>
	);
}

export default RenderPhoneField;
